
<button mat-menu-item class="d-flex justify-content-between "
[ngClass]="{'root-drop' : isRoot}"
[matMenuTriggerFor]="menu" >
 <span> {{trigger}} </span>
  <mat-icon *ngIf="isRoot">arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let node of filterOptions; let i = index">
    <button mat-menu-item>
      <app-menu
        [data]="node"
        [trigger]="node.key"
        [fieldName]="fieldName"
        *ngIf="isExpandable(node); else menuItem"
        (optionSelected)="onChildOptionSelected($event)"
      ></app-menu>
    </button>
    <ng-template #menuItem>
      <button mat-menu-item
      (click)="selectOption(node , fieldName)"
      >{{ node.key }}</button>
    </ng-template>
  </ng-container>
</mat-menu>
